<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Gemeinsam</h1>
                <p class="h2">Wenn Nutzende erfolgreich sind, wollen sie es mit anderen teilen. Kein Problem, wir haben ja unser Diskussionsforum mit unserer Vitadio-Community...</p>
            </div>
            <div class="right-wrapper">
                <h2>Wie unterstützt die Vitadio-Community?</h2>
                <p class="text">Das Teilen von Erfolgen innerhalb einer Gruppe ist hilfreich, da Gleichgesinnte verstehen, wie anstregend es ist, am eigenen Lebensstil zu arbeiten.Ebenso entsteht durch den Austausch über Misserfolge Verständnis und Unterstützung, da man erkennt, wie leicht Rückschläge bei der Änderung des Lebensstils passieren können.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 23
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

